import { IHttpProvider, IHttpResponseTransformer } from 'angular';
import { apexApiResponseInterceptorFactory } from '../interceptors/apex-api-response.interceptor';
import { apexAuthInterceptorFactory } from '../interceptors/apex-auth.interceptor';
import { apexWarningInterceptorFactory } from '../interceptors/apex-warning.interceptor';
import { XHttpMethodOverrideInterceptor } from '../interceptors/x-http-method-override.interceptor';
import { convertDateStringsToDates } from './parse-dates.helper';
import { retryServiceUnavailableInterceptorFactory } from '../interceptors/retry-503.interceptor';

/**
 * Configure the given $http service provider.
 * @param $httpProvider The angular $http service provider being configured.
 */
export function configureHttpProvider($httpProvider: IHttpProvider) {
    'ngInject'
    // Allow $http to make cross-domain calls to the API.
    $httpProvider.defaults.withCredentials = true;
    delete $httpProvider.defaults.headers.common["X-Requested-With"];

    // Parse date strings in ISO 8601 format into date objects.
    ($httpProvider.defaults.transformResponse as IHttpResponseTransformer[]).push(convertDateStringsToDates);

    // Add an interceptor in order to support environments where PUT/PATCH/DELETE verbs are blocked.
    $httpProvider.interceptors.push(XHttpMethodOverrideInterceptor);
    // Automatically add auth-related headers to the request.
    $httpProvider.interceptors.push(apexAuthInterceptorFactory);
    // Log warnings returned in the Warning header from the API.
    $httpProvider.interceptors.push(apexWarningInterceptorFactory);
    // Handle request errors and boxing into specific errors.
    $httpProvider.interceptors.push(apexApiResponseInterceptorFactory);
    // Automatically retry requests that return 503, since it's normal to have some downtime when deploying updates.
    $httpProvider.interceptors.push(retryServiceUnavailableInterceptorFactory);
}
